import request, { IWorkspaceResponse } from '/@/api/http/request'

// DRC 链路
const API_PREFIX = '/manage/api/v1'

export interface AlarmQueryParam {
    algorithm_name: string
    algorithm_id: string
    device_name: string
    start_time: string
    end_time: string
    alarm_level: string
    sort_field: string
    order_by: string
    job_id: string
}

export interface AlarmPageRequest {
    page: number
    page_size: number
    param: AlarmQueryParam
}

// 告警信息列表
export interface AlarmParam {
  device_name : string // 设备名称
  alarm_time : string // 告警时间
  alarm_code : string // 告警编码
  alarm_level : string // 告警等级
  alarm_message : string // 告警信息
}

/**
 * 分页接口
 * @param body
 * @returns
 */
export const getAlarmPage = async function (body: AlarmPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/alarm/page`
  const result = await request.post(url, body)
  return result.data
}

/**
 * 分页接口
 * @param body
 * @returns
 */
export const deletAlarm = async function (ids: string): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/alarm/delete-alarm/${ids}`
  const result = await request.delete(url)
  return result.data
}

/** 保存-更新算法模型配置 */
export const saveAlgorithmModel = async function (body: any): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/algorithm-model/save-or-update`
  const result = await request.post(url, body)
  return result.data
}

// 告警详情
export const getAlarmData = async function (id): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/alarm/get-alarm-detail/${id}`
  const result = await request.get(url)
  return result.data
}
